import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {TenantInformationService} from '../services/tenant-information.service';
import {ThemeService} from '../services/theming.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor(private readonly tenantInformationService: TenantInformationService, private readonly themingService: ThemeService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.headers.has('Tenant')) {
            this.tenantInformationService.setTenant(event.headers.get('Tenant')!);
            this.themingService.loadCustomerTheme();
            this.themingService.setFavicon();
          }
        }
      ));
  }
}
